import { Box, Typography, Link, Sheet } from '@mui/joy';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

export const NotFound: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.level1',
        animation: 'fade-in 0.3s ease-in',
      }}
    >
      <Sheet
        variant="outlined"
        sx={{
          p: 4,
          borderRadius: 'lg',
          boxShadow: 'lg',
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <Typography level="h2">{t('Page Not Found')}</Typography>
        <Typography level="body-sm" sx={{ mt: 1, mb: 3 }}>
          {t('The page you are looking for does not exist.')}
        </Typography>
        <Link component="button" color="primary" onClick={() => navigate('/')}>
          {t('Go to Home')}
        </Link>
      </Sheet>
    </Box>
  );
};

export default NotFound;
